<template>
  <div class="d-flex flex-wrap">
    <template v-if="loading">
      <v-skeleton-loader
        v-for="n in 3"
        :key="n"
        type="card"
        class="mx-2 my-2"
        max-width="300"
      />
    </template>
    <template v-else>
      <v-card
        v-for="(item, index) in items"
        :key="index"
        max-width="300"
        elevation="0"
        class="mx-2 last-seen-card active-card"
        :class="{
          'disabled-card': disabled,
        }"
        @click="showLastSeen(item.customer_id)"
      >
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="text-danger"
              >{{ item.customer_id }} | {{ item.channel }}</v-list-item-title
            >
            <v-list-item-subtitle class="font-weight-bold text-dark">
              {{ item.name }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <p class="text-dark">
                Zona: {{ item.zone }} | Domicilios:
                {{ item.reception_count ?? 0 }}
              </p>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </template>
  </div>
</template>
<script>
  export default {
    name: 'LastSeenCard',
    props: {
      items: {
        type: Array,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        active: false,
        activeCustomerId: null,
      };
    },
    methods: {
      showLastSeen(id) {
        if (this.disabled) return;
        this.activeCustomerId = id;
        this.$emit('showLastSeen', id);
      },
    },
  };
</script>
<style scoped>
  .last-seen-card:hover {
    cursor: pointer;
    transition: box-shadow 0.3s ease-in-out !important;
    border: 1px solid rgba(200, 35, 51, 1) !important;
  }
  .active-card {
    border: 1px solid rgba(200, 35, 51, 1) !important;
    box-shadow: 0 2px 8px rgba(200, 35, 51, 0.3) !important;
  }

  .disabled-card {
    cursor: not-allowed !important;
    opacity: 0.6 !important;
    background-color: #f5f5f5 !important;
  }
</style>
